// import logo from './logo.svg';
import "./App.css";
import Tarjeta from "./tarjeta";

function App() {
  return (
    <div className="App">
      <Tarjeta />
    </div>
  );
}

export default App;
